import { get, post } from "../api";

export function top10() {
  return get("/my-announcement/top10",null);
}
export function getPaging(data) {
  return post("/my-announcement/paging", data);
}

export function getById(id) {
  return get("/my-announcement/get/" + id,null);
}
export function changeStatus(id) {
  return get("/my-announcement/changeRead/" + id,null);
}
export function getUnreadCount() {
  return get("/my-announcement/unread-count",null);
}
export function firstPopup() {
  return get("/my-announcement/firstPopup",null);
}
